
import { call, put } from "redux-saga/effects";
import { updateUser, authenticateUser,updateAccessToken } from "../store/user";
import { API_URLS } from "../resources/constants";
import { formQueryString } from '../resources/functions'
import {CallApi} from './callApi'

export function* fetchClientId(action: any): any {
  try {
    const url = API_URLS.GUSTO.FETCH_CLIENTID
    let result = yield call(CallApi.GET, url,{},true);
    action && action.callbackSuccess(result);
  } catch (e) {
    action && action.callbackError(e)
  }
}

export function* callback(action: any): any {
  try {
    const payload = action.payload;
    const url = API_URLS.GUSTO.CALLBACK + '?' + formQueryString(payload)
    let result = yield call(CallApi.GET, url,{},true);
    //yield put(updateUser(result.data));
    action && action.callbackSuccess(result);
  } catch (e) {
    action && action.callbackError(e)
  }
}

export function* importData(action: any): any {
  try {
    const payload = action.payload;
    const url = API_URLS.GUSTO.IMPORT_DATA + '?' + formQueryString(payload)
    let result = yield call(CallApi.GET, url,{},true);
    //yield put(updateUser(result.data));
    action && action.callbackSuccess(result);
  } catch (e) {
    action && action.callbackError(e)
  }
}

export function* fetchEarningTypes(action: any): any {
  try {
    const payload = action.payload;
    const url = API_URLS.GUSTO.FETCH_EARNING_TYPES + '?' + formQueryString(payload)
    let result = yield call(CallApi.GET, url,{},true);
    //yield put(updateUser(result.data));
    action && action.callbackSuccess(result);
  } catch (e) {
    action && action.callbackError(e)
  }
}

export function* postEarningTypes(action: any): any {
  try {
    const { records, branch_id } = action.payload;
    const url = API_URLS.GUSTO.POST_EARNING_TYPES + '?branch_id=' + branch_id;
    let result = yield call(CallApi.POST, url, records,true);
    //yield put(updateUser(result.data));
    action && action.callbackSuccess(result);
  } catch (e) {
    action && action.callbackError(e)
  }
}

export function* fetchPayrollJournalList(action: any): any {
  try {
    const payload = action.payload;
    const url = API_URLS.GUSTO.FETCH_PAYROLL_JOURNAL_LIST + '?' + formQueryString(payload)
    let result = yield call(CallApi.GET, url, {}, true);
    action && action.callbackSuccess(result);
  } catch (e) {
    action && action.callbackError(e)
  }
}

export function* fetchPayrollJournalDetails(action: any): any {
  try {
    const { id, branch_id } = action.payload;
    const url = API_URLS.GUSTO.FETCH_PAYROLL_JOURNAL_DETAILS + id + '?branch_id=' + branch_id;
    let result = yield call(CallApi.GET, url, {}, true);
    action && action.callbackSuccess(result);
  } catch (e) {
    action && action.callbackError(e)
  }
}

export function* verifyAndSubmitJournal(action: any): any {
  try {
    const { id, branch_id } = action.payload;
    const url = API_URLS.GUSTO.VERIFY_AND_SUBMIT_JOURNAL + id + '?branch_id=' + branch_id;
    let result = yield call(CallApi.POST, url, {}, true);
    action && action.callbackSuccess(result);
  } catch (e) {
    action && action.callbackError(e)
  }
}